import {FC} from "react";

export const Placeholder: FC = () => {
  return null;
};
